import { useEffect, useState } from "react";
import { adminApi } from "@/admin/AdminAuthContext";
import AdminPageShell from "@/admin/AdminPageShell";

const STATUS_COLORS = { pending: "var(--gg-logo-gold)", confirmed: "#8FBF9F", cancelled: "var(--gg-muted-text)", completed: "var(--gg-secondary-text)" };

const AdminAppointments = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => adminApi.get("/appointments").then((res) => setItems(res.data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    await adminApi.patch(`/appointments/${id}/status`, { status });
    load();
  };

  return (
    <AdminPageShell title="Appointments" description="Review and confirm booking requests submitted via the Contact page." testId="admin-appointments-page">
      {loading ? <p className="text-small">Loading…</p> : (
        <div className="space-y-3">
          {items.map((a) => (
            <div key={a.id} className="neu-surface p-5 flex items-center justify-between gap-4 flex-wrap" data-testid={`admin-appointment-row-${a.id}`}>
              <div>
                <p className="text-body font-semibold" style={{ color: "var(--gg-ivory)" }}>{a.full_name} &middot; {a.email}</p>
                <p className="text-small">{a.brand_or_service || "General"} {a.preferred_date ? `· ${a.preferred_date}` : ""} {a.preferred_time ? `· ${a.preferred_time}` : ""}</p>
              </div>
              <select value={a.status} onChange={(e) => updateStatus(a.id, e.target.value)} className="neu-inset h-10 px-3" style={{ color: STATUS_COLORS[a.status] }} data-testid={`admin-appointment-status-${a.id}`}>
                <option value="pending">Pending</option>
                <option value="confirmed">Confirmed</option>
                <option value="completed">Completed</option>
                <option value="cancelled">Cancelled</option>
              </select>
            </div>
          ))}
          {items.length === 0 && <p className="text-small">No appointment requests yet.</p>}
        </div>
      )}
    </AdminPageShell>
  );
};

export default AdminAppointments;
